import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { TransactionChats } from '@ui/src';
import { useAppSelector } from '@store';
import useProblemIncomingTransaction from '../hooks/use-incoming';

const IncomingTransactionChats = (): React.JSX.Element => {
  const { chats, transaction, recipientAccounts } = useAppSelector(
    (state) => state.customersProblemTransactions.incoming,
  );
  const { currentEmployee } = useAppSelector(
    (state) => state.customersDictionaries,
  );
  const { currencies: currenciesList, activePermissions } = useAppSelector(
    (state) => state.root,
  );

  const { transactionId } = useParams();

  const {
    getRecipientAccounts,
    onCreateTransactionChat,
    chatCreateInProgress,
  } = useProblemIncomingTransaction({
    transaction,
    transactionId,
    currentEmployee,
    currenciesList,
  });

  useEffect(() => {
    if (
      transaction &&
      transaction.recipientAccount &&
      transaction.recipientAccount?.organization?.type === 'CORPORATE' &&
      !recipientAccounts
    ) {
      getRecipientAccounts(transaction.recipientAccount.organizationId);
    }
  }, [transaction, recipientAccounts]);

  return (
    <TransactionChats
      chats={chats}
      companyOfficials={recipientAccounts}
      individualCustomer={transaction?.recipientAccount}
      onCreateTransactionChat={onCreateTransactionChat}
      chatCreateInProgress={chatCreateInProgress}
      currentEmployee={currentEmployee}
      activePermissions={activePermissions}
    />
  );
};

export default IncomingTransactionChats;
